import BridgeIcon from './BridgeIcon'

export default BridgeIcon
